module.exports = __webpack_public_path__ + "img/avatar.41159a50.png";